<template>
  <v-col cols="12" class="px-0 pt-2 mt-0">
    <v-list class="py-0 my-0">
      <v-list-subheader>
        <span style="line-height: 36px">Иностранные языки:</span>
        <v-btn icon flat size="x-small" v-show="edit" @click="$emit('add')">
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </v-list-subheader>
      <v-list-item
        v-for="(item, i) in languages"
        :key="i"
        active-color="primary"
      >
        <template v-slot:prepend>
          <v-icon color="primary">language</v-icon>
        </template>
        <template v-slot:append>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('edit', item)">
            <v-icon color="primary">edit</v-icon>
          </v-btn>
          <v-btn icon flat size="x-small" v-show="edit" @click="$emit('delete', item)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </template>
        <v-list-item-title :class="(item.is_native)?'font-weight-black text-wrap':'text-wrap'">
          {{ item.language.text }}
          <span v-if="!item.is_native">({{ item.level }}) </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="languages && languages.length === 0">
        <template v-slot:prepend>
          <v-icon color="primary">language</v-icon>
        </template>
        <v-list-item-title>
          <span>не указан</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
export default {
  name: "LanguagesSection",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['add', 'edit', 'delete']
}
</script>

<style lang="scss" scoped>

</style>
